import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";
import CompanionTagline from "../CompanionTagline/CompanionTagline";
import styles from "./CompanionBrief.module.scss";

const watchingItems = [
  {
    color: "orange",
    title: "Brightwave renewal",
    description: "Quiet for 5 days — nudge ready",
  },
  {
    color: "green",
    title: "Orbit champion changed roles",
    description: "New contact found and mapped",
  },
  {
    color: "pink",
    title: "Pricing reply due today",
    description: "Draft waiting for your review",
  },
];

const CompanionBrief = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.2 });

  return (
    <motion.section
      id="companion-brief"
      ref={ref}
      className={styles.section}
      initial={{ opacity: 0, y: 40 }}
      animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 40 }}
      transition={{ duration: 0.7, ease: "easeOut" }}
    >
      <div className="container-custom">
        <div className={styles.browserFrame}>
          <div className={styles.browserBar}>
            <div className={styles.windowDots}>
              <span className={styles.dotRed} />
              <span className={styles.dotYellow} />
              <span className={styles.dotGreen} />
            </div>
            <div className={styles.urlBar}>app.vertik.ai</div>
            <div className={styles.liveBadge}>
              <span className={styles.liveDot} />
              Live
            </div>
          </div>

          <div className={styles.briefContent}>
            <div className={styles.leftPanel}>
              <div className={styles.briefLabel}>
                <span className={styles.briefIcon} aria-hidden="true">
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7 1.5L7.8 5.2L11.5 6L7.8 6.8L7 10.5L6.2 6.8L2.5 6L6.2 5.2L7 1.5Z"
                      fill="white"
                    />
                    <path
                      d="M11 2.5L11.4 4.1L13 4.5L11.4 4.9L11 6.5L10.6 4.9L9 4.5L10.6 4.1L11 2.5Z"
                      fill="white"
                      opacity="0.7"
                    />
                  </svg>
                </span>
                Live Companion Brief
              </div>

              <h2 className={styles.greeting}>Good morning, Maya.</h2>
              <p className={styles.intro}>
                Your day&apos;s ready. Three deals need you today — I&apos;ve
                prepped each one, so you can start selling, not sorting.
              </p>

              <div className={styles.firstMoveCard}>
                <span className={styles.firstMoveLabel}>First Move</span>
                <h3 className={styles.firstMoveTitle}>
                  Send the Lumen proposal
                </h3>
                <p className={styles.firstMoveDescription}>
                  Drafted and ready — I pulled the pricing, attached the case
                  study, and queued the follow-up.
                </p>
                <button type="button" className={styles.reviewBtn}>
                  <span>Review &amp; send</span>
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                  >
                    <path
                      d="M3.5 10.5L10.5 3.5"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M5.5 3.5H10.5V8.5"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              </div>
            </div>

            <div className={styles.divider} />

            <div className={styles.rightPanel}>
              <h3 className={styles.watchingLabel}>Watching For You</h3>
              <ul className={styles.watchingList}>
                {watchingItems.map((item) => (
                  <li key={item.title} className={styles.watchingItem}>
                    <span
                      className={`${styles.statusDot} ${styles[item.color]}`}
                    />
                    <div>
                      <p className={styles.watchingTitle}>{item.title}</p>
                      <p className={styles.watchingDescription}>
                        {item.description}
                      </p>
                    </div>
                  </li>
                ))}
              </ul>
              <p className={styles.watchingFooter}>
                Nothing slips. I&apos;ll keep watching while you sell.
              </p>
            </div>
          </div>
        </div>
        <CompanionTagline />
      </div>
    </motion.section>
  );
};

export default CompanionBrief;
